/* eslint-disable react/no-danger */
import React from 'react'
import { getModifiedHtml } from './helper'
import styles from './comparisonTable.module.scss'

const ComparisonTable = ({ data }) => {
  const { tableContent, tableSectionHeading } = data?.data?.attributes
  const { isSemPage } = data
  const updatedHtmlContent = getModifiedHtml(tableContent, styles)

  return (
    <div className={`${styles.comparisonTable} ${!isSemPage ? styles.seoStyles : ''} white`}>
      <div className={styles.sectionHeading} dangerouslySetInnerHTML={{ __html: tableSectionHeading }} />
      <div className={styles.compareTableStyles} dangerouslySetInnerHTML={{ __html: updatedHtmlContent }} />
    </div>
  )
}

export default ComparisonTable
